export default __webpack_public_path__ + "static/media/Whatsapp.88e27211.png";